// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Figure$ReactTemplate = require("./Figure.bs.js");

function FigurePreviews(Props) {
  var figures = Props.figures;
  return React.createElement("ul", {
              style: {
                display: "flex",
                margin: "0",
                padding: "0"
              }
            }, figures.map((function (param) {
                    var name = param[0];
                    return React.createElement("li", {
                                key: name,
                                style: {
                                  display: "flex",
                                  padding: "5px 10px",
                                  alignItems: "center",
                                  flexDirection: "column",
                                  justifyContent: "space-between"
                                }
                              }, React.createElement(Figure$ReactTemplate.make, {
                                    coords: param[1]
                                  }), React.createElement("span", undefined, name));
                  })));
}

var make = FigurePreviews;

exports.make = make;
/* react Not a pure module */
